import { render, staticRenderFns } from "./BaodanCar.vue?vue&type=template&id=15df3147&scoped=true"
import script from "./BaodanCar.vue?vue&type=script&lang=js"
export * from "./BaodanCar.vue?vue&type=script&lang=js"
import style0 from "./BaodanCar.vue?vue&type=style&index=0&id=15df3147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df3147",
  null
  
)

export default component.exports